import React, { useState, useEffect } from "react";
import Sidenavbar from "../../Sidenavbar";
import Topbar from "../../Topbar";
import "../../../styles/CommonStyle.scss";
import "../../../styles/Meetings.scss";
import ReactPaginate from "react-paginate";
import { baseURL } from "../../BaseUrl";
// import { travelizeAuth } from "./HeaderAuthentication";
import { exportExcel } from "../../DownloadFile";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { optionsPageSizeList } from "../../DropdownsData";
import AccessDenied from "../../../AccessDenied";
import { Col, Image, Row } from "react-bootstrap";
import mobileimg from "../../../images/iphone.svg";
import { useNavigate } from "react-router-dom";
import OnScrollLoading, { handleScroll } from "../../OnScrollLoading";
import SbCancelBtn from "../../SbButtons/SbCancelBtn";
import { SbDownloadBtn } from "../../SbButtons/SbAddBtn";
import Footer from "../../Footer";

function DeviceDetails() {
  const [menuCollapse, setMenuCollapse] = useState(false);
  const [toggleshift, setToggleshift] = useState({ style: "" });
  const [deviceDetails, setDeviceDetails] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [subType, setSubType] = useState(0);
  const [userList, setUserList] = useState([]);
  const [filterUserId, setFilterUserId] = useState("");
  const [companyName, setCompanyName] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // Lazy Loading
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  let userDetails = JSON.parse(sessionStorage.getItem("usdtls"));

  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };

  const toggleMenu = () => {
    if (menuCollapse === true) {
      setMenuCollapse(false);
      setToggleshift({ style: "" });
    } else {
      setMenuCollapse(true);
      setToggleshift({ style: "toggle-shift-left" });
    }
  };

  // PAGINATION START
  const [PageSize, setPageSize] = useState(20);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalemployee, setTotalemployee] = useState("");
  const [pageDataSize, setPageDataSize] = useState("");
  const [itemOffset, setItemOffset] = useState(1);
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const pageDataFrom = currentPage * PageSize - PageSize + 1;
  const pageDataTill = pageDataFrom + pageDataSize - 1;
  // console.log("From:", pageDataFrom, "TO", pageDataTill);
  // PAGINATION END

  useEffect(() => {
    fetchDropdownData();
  }, [subType]);

  const fetchDropdownData = () => {
    let requestOptionZone = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Subscription/BindUsersDropDown?SubscriptionId=${subType}`,
      requestOptionZone
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          // console.log("USER-DROPDOWN::", res.result);
          setUserList(
            res.result.map((data) => {
              return { value: data.userId, label: data.userFullName };
            })
          );
        } else {
          setUserList([]);
        }
      });
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  const fetchDropdowns = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Subscription/BindCompanyDropdown?SubscriptionTypeID=0`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setCompanyList(
            res.result.map((data) => {
              return {
                value: data.subscriptionID,
                label: data.companyName,
              };
            })
          );
        } else {
          setCompanyList([]);
        }
      });
  };

  // GET SUBSCRIPTION PAGE START
  useEffect(() => {
    fetchdeviceDetails();
  }, [PageSize, currentPage, subType, filterUserId, companyName]);

  const fetchdeviceDetails = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };

    fetch(
      `${baseURL}/api/SupportTeam/GetAllDevices?SubscriptionId=${subType}&UserId=${filterUserId}&PageSize=${PageSize}&CurrentPage=${currentPage}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setDeviceDetails(res.result);
          setPageCount(Math.ceil(res.recordCount[0] / PageSize));
          setTotalData(res.recordCount[0]);
          setIsLoading(false);
          setLoading(false);
        } else {
          setDeviceDetails("");
          setIsLoading(false);
          setLoading(false);
        }
      });
  };

  // GET SUBSCRIPTION PAGE END

  const clearSerachBySelect = () => {
    setSubType(0);
    setFilterUserId("");
    // setCompanyName("");
  };

  const exportExcelDeviceDetails = () => {
    exportExcel(
      `${baseURL}/api/Export/DeviceExcelExport?SubscriptionId=${companyName}&UserId=${filterUserId}&PageSize=${PageSize}&CurrentPage=${currentPage}`,
      "DeviceDetails.xlsx"
    );
  };

  // Page navigation
  const Navigate = useNavigate();
  const goToBackPage = () => {
    Navigate(-1);
  };
  // page navigation

  return (
    <div id="main-page">
      {userDetails !== null && userDetails !== "" ? (
        <>
          {/* SIDEBAR START */}
          <Sidenavbar menuCollapse={menuCollapse} toggleshift={toggleshift} />
          {/* SIDEBAR END */}

          {/* TOPBAR START */}
          <Topbar
            toggleMenu={toggleMenu}
            menuCollapse={menuCollapse}
            toggleshift={toggleshift}
          />
          {/* TOPBAR END */}

          {/* MAIN BODY START */}
          <div className="page-wrapper">
            {/* PAGE CONTENT START */}
            <div className={`main-body ${toggleshift.style}`}>
              <div className="page-content">
                {/* Filter and Header Section */}
                <div className="user-table">
                  <Row className="search-row">
                    <Col md={6} className="cat-col">
                      <div className="page-header-text-div">
                        <div className="back-btn" onClick={goToBackPage}>
                          <img
                            src="../../../../images/DefaultImages/back-btn-arrow.svg"
                            alt=""
                          />
                        </div>
                        <h6 className="page-header-text">DEVICE DETAILS</h6>
                      </div>
                    </Col>
                    <Col md={6} className="cat-col">
                      <div
                        className="search-bar-header"
                        style={{ float: "right" }}
                      >
                        <div className="page-top-bar-dropdowns page-top-Filters">
                          <div style={{ width: "100%" }}>
                            <div className="clients-filter-input-boxs filter-box-div d-flex">
                              <div
                                style={{ width: "100%", padding: "0px 5px" }}
                              >
                                <Select
                                  className="react-select-container-list"
                                  classNamePrefix="react-select-list"
                                  options={companyList}
                                  placeholder="Select Company"
                                  value={subType === 0 ? "" : companyList.value}
                                  onInputChange={companyList.label}
                                  onChange={(data) => setSubType(data.value)}
                                  isSearchable={true}
                                />
                              </div>
                              <div
                                style={{ width: "100%", padding: "0px 5px" }}
                              >
                                <Select
                                  className="react-select-container-list"
                                  classNamePrefix="react-select-list"
                                  options={userList}
                                  placeholder="Select User"
                                  value={
                                    filterUserId === "" ? "" : userList.value
                                  }
                                  onInputChange={userList.label}
                                  onChange={(data) =>
                                    setFilterUserId(data.value)
                                  }
                                  isSearchable={true}
                                />
                              </div>
                              <div className="clients-filter-input-boxs filter-box-div">
                                <SbCancelBtn
                                  onClickEffect={clearSerachBySelect}
                                  btnName="Clear"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* Filter and Header Section */}
                {/* USER TABLE START */}
                <div className="meetings-table">
                  <div
                    className="table-responsive meetings-scrollbar"
                    onScroll={(e) =>
                      handleScroll(
                        e,
                        deviceDetails,
                        totalData,
                        setLoading,
                        setPageSize,
                        PageSize
                      )
                    }
                  >
                    <table className="table meetings-list-table">
                      <thead className="thead-light meetings-list-thead">
                        <tr>
                          <th>USER NAME</th>
                          <th>DEVICE INFO</th>
                          <th>BATTERY</th>
                          <th>STORAGE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {deviceDetails !== "" ? (
                          deviceDetails?.map((data, i) => (
                            <tr className="meeting-list-row-data" key={i}>
                              <td>
                                <p className="d-flex">
                                  <Image
                                    src={mobileimg}
                                    alt="Mobile-device"
                                    className="mobile-img"
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      //   paddingRight: "5px",
                                    }}
                                  />
                                  <p>
                                    <b>{data?.userFullName}</b>
                                    <br />
                                    {moment(data?.date).format("DD/MM/YYYY")}
                                  </p>
                                </p>
                              </td>
                              <td>
                                <p>
                                  <b>Name : </b>
                                  {data?.name}
                                </p>
                                <p>
                                  <b>Modal : </b> {data?.modal ?? "NA"}
                                </p>
                                <p>
                                  <b>OS : </b> {data?.os}
                                </p>
                                <p>
                                  <b>Version : </b> {data?.osVersion}
                                </p>
                              </td>
                              <td>
                                <b>Tech : </b> {data?.batteryTech} <br />
                                <b>Health : </b> {data?.batteryHealth}
                                <br />
                                <b>Power : </b> {data?.batteryPower} <br />
                              </td>
                              <td>
                                <b>RAM : </b> {data?.ram}
                                <br />
                                <b>Rooted : </b>
                                {data?.rooted}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <h6 className="no-data-found">
                            ------ NO DATA FOUND ------
                          </h6>
                        )}
                        {loading && <OnScrollLoading />}
                      </tbody>
                    </table>
                  </div>
                  <div className="download-and-pagination">
                    <SbDownloadBtn onClickEffect={exportExcelDeviceDetails} />
                    
                  </div>
                </div>
                {/* USER TABLE END */}

                {/* PAGE CONTENT END*/}
              </div>
            </div>

            {/* MAIN BODY END */}
          </div>
          <Footer />
        </>
      ) : (
        <AccessDenied />
      )}
    </div>
  );
}

export default DeviceDetails;